import React from 'react';
import accordion1 from "../../../../content/contrast/react/components/images/accordiondefault.png";
import accordion2 from "../../../../content/contrast/react/components/images/accordionwithouticon.png";
export default {
  React,
  accordion1,
  accordion2
};